<main id="maincontent" role="main">
  <section class="rs-es-first-section">
    <div class="row">
      <div class="columns small-12">
        <div class="small-only-text-center">
          <div
            class="panel rs-inline-block rs-wd-s30 rs-wd-m31 rs-h-s4 rs-h-m5 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
          ></div>
        </div>

        <div class="rs-panel-big rs-bg-c2 clearfix">
          <div class="small-only-text-center">
            <div
              class="panel rs-inline-block rs-wd-s16 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
            ></div>
          </div>

          <div class="row">
            <div class="columns small-12 medium-8">
              <div
                class="panel rs-maxw rs-h-s4 rs-h-m5 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
              ></div>
            </div>
          </div>
          <div class="panel rs-bg-grey1">
            <div
              class="panel rs-wd-s15 rs-wd-m20 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
            ></div>

            <div class="rs-flex-row">
              <div class="rs-flex-columns small-12 medium-6">
                <div class="rs-panel-flex">
                  <div class="rs-panel-flex-cell rs-bg-c2 rs-border">
                    <div class="rs-flex-row rs-flex-middle rs-maxh rs-justify-right">
                      <div class="rs-flex-column">
                        <div
                          class="panel rs-wd-s19 rs-wd-m26 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                        ></div>
                      </div>
                      <div class="rs-flex-column rs-flex-shrink rs-flex-middle">
                        <div class="rs-flex-row rs-flex-middle">
                          <div class="rs-flex-columns rs-flex-grow">
                            <div
                              class="panel rs-wd-s8 rs-wd-m10 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                            ></div>
                          </div>
                          <div class="rs-flex-columns">
                            <div
                              class="panel rs-inline-block rs-wd-s3 rs-h-s3 rs-no-padding rs-radius-circle rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                            ></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="rs-flex-columns small-12 medium-6">
                <div class="rs-panel-flex">
                  <div class="rs-panel-flex-cell rs-bg-c2 rs-border">
                    <div class="rs-flex-row rs-flex-middle rs-maxh rs-justify-right">
                      <div class="rs-flex-column">
                        <div
                          class="panel rs-wd-s19 rs-wd-m26 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                        ></div>
                      </div>
                      <div class="rs-flex-column rs-flex-shrink rs-flex-middle">
                        <div class="rs-flex-row rs-flex-middle">
                          <div class="rs-flex-columns rs-flex-grow">
                            <div
                              class="panel rs-wd-s8 rs-wd-m10 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                            ></div>
                          </div>
                          <div class="rs-flex-columns">
                            <div
                              class="panel rs-inline-block rs-wd-s3 rs-h-s3 rs-no-padding rs-radius-circle rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                            ></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="rs-flex-row">
            <div class="rs-flex-columns small-12 medium-8">
              <div class="panel rs-bg-grey1 clearfix">
                <div
                  class="panel rs-wd-s15 rs-wd-m20 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                ></div>

                <div class="panel clearfix">
                  <div class="rs-flex-row rs-flex-dir-col-small-only">
                    <div class="rs-flex-column">
                      <div
                        class="panel rs-wd-s15 rs-wd-m20 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                      ></div>

                      <div
                        class="panel rs-maxw rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading hide-for-medium-up"
                      ></div>
                      <div
                        class="panel rs-maxw rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                      ></div>
                    </div>
                    <div class="rs-flex-column rs-flex-shrink">
                      <div class="rs-flex-row rs-flex-middle-medium rs-flex-dir-col-small-only">
                        <div class="rs-flex-column">
                          <div class="small-only-text-center">
                            <div
                              class="panel rs-inline-block rs-wd-s5 rs-wd-m7 rs-h-s4 rs-h-m5 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                            ></div>
                          </div>
                        </div>
                        <div class="rs-flex-column rs-flex-shrink">
                          <div
                            class="panel rs-inline-block rs-maxw rs-wd-m8 rs-h-s4 rs-h-m5 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="rs-flex-columns small-12 medium-4">
              <div class="panel rs-bg-grey1 clearfix">
                <div
                  class="panel rs-wd-s15 rs-wd-m20 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                ></div>

                <div
                  class="panel rs-maxw rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                ></div>
                <div
                  class="panel rs-maxw rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                ></div>
                <div
                  class="panel rs-maxw rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                ></div>
                <div
                  class="panel rs-maxw rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                ></div>

                <div
                  class="panel rs-wd-s10 rs-wd-m14 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>
